import createRequestService from '@/utils/createRequestService'

export default createRequestService({
  baseURL: process.env.VUE_APP_AIRDROP_API,
  attachToken: false,
  defaultContentType: 'application/json;charset=utf-8'
})
